import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/cb2d290d-77fd-46ed-998a-9e142da2d251";
export const REGISTER_URL = "https://a.ntrk2.com/21dd6901-7a18-4a3b-9bff-7ccb1ed47593";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://789cr.kzw2a.com/download?openExternalBrowser=1&id=udpa97k0cun83ti";

export * from "./codes";
export * from "./context";
